"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var config_1 = require("../../config");
var actions_1 = require("./actions");
var APP_CONFIG = (0, config_1.getConfig)();
var KEYCLOAK_CONFIG = {
    url: APP_CONFIG.KEYCLOAK_URL,
    realm: APP_CONFIG.KEYCLOAK_REALM,
    clientId: APP_CONFIG.KEYCLOAK_CLIENTID,
};
var AuthWrapperComponent = /** @class */ (function (_super) {
    __extends(AuthWrapperComponent, _super);
    function AuthWrapperComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthWrapperComponent.prototype.componentDidMount = function () {
        var _a = this.props, _b = _a.config, config = _b === void 0 ? KEYCLOAK_CONFIG : _b, options = _a.options, authenticationDisabled = _a.authenticationDisabled, dispatch = _a.dispatch;
        dispatch((0, actions_1.initAuthentication)(config, options, authenticationDisabled));
    };
    AuthWrapperComponent.prototype.render = function () {
        var children = this.props.children;
        // TODO: display a loading indicator until KeyCloak has initialized?
        return children;
    };
    return AuthWrapperComponent;
}(React.PureComponent));
exports.default = (0, react_redux_1.connect)()(AuthWrapperComponent);
